<template>
  <div class="container">
    <nav class="add-navigation">
      <div @click="$router.push({name: 'reseller-vendors-list'})" class="back-link">
        <svg class="icon" width="30px" height="30px" viewBox="0 0 30 30" version="1.1">
          <path
            d="M9.82106781,14.25 L23,14.25 L23,16.25 L9.84421387,16.25 L11.6568542,18.0626404 L10.2426407,19.4768539 L7.41842728,16.6526405 L7.41421356,16.6568542 L7.00735931,16.25 L7,16.25 L7,16.2426407 L6,15.2426407 L6.00421371,15.238427 L6,15.2342133 L7.41421356,13.8199997 L7.41842728,13.8242134 L10.2426407,11 L11.6568542,12.4142136 L9.82106781,14.25 Z"
            id="path-1"
          ></path>
        </svg>
        <p>Back to Vendors</p>
      </div>
      <div class="buttons-wrapper">
        <div @click="$router.push({name: 'reseller-vendors-list'})" class="secondary-button">
          <secondary-button>Cancel</secondary-button>
        </div>
        <div class="primary-button">
          <primary-button @click.native="addVendor">Save Vendor</primary-button>
        </div>
      </div>
    </nav>
    <div class="add-container">
      <span class="container-title">Edit Vendor</span>
      <div class="col-wrapper">
        <div class="col">
          <primary-input
            type="text"
            name="company name"
            class="field"
            v-model="vendor.vendor_name"
            v-validate="'required'"
            :class="{'input': true, 'is-danger': errors.has('company name')}"
            placeholder="Enter company name"
          />
          <div
            class="help is-danger"
            v-if="errors.has('company name')"
          >{{ errors.first('company name') }}</div>
          <primary-select
            type="text"
            name="type"
            v-validate="'required'"
            v-model="vendor.vendor_type"
            :class="{'input': true, 'is-danger': errors.has('type')}"
            placeholder="type"
          >
            <option v-for="(i, k) in type" :value="i" :key="k">{{i}}</option>
          </primary-select>
          <div v-if="errors.has('type')" class="help is-danger">{{ errors.first('type') }}</div>
          <primary-input
            type="text"
            name="sales email"
            v-model="vendor.sales_email"
            v-validate="'required|email'"
            :class="{'input': true, 'is-danger': errors.has('sales email')}"
            placeholder="Enter seles name"
          />
          <div
            class="help is-danger"
            v-if="errors.has('sales email')"
          >{{ errors.first('sales email') }}</div>
        </div>
        <div class="col">
          <primary-input
            type="text"
            name="contact"
            v-model="vendor.contact_person"
            v-validate="'required'"
            :class="{'input': true, 'is-danger': errors.has('contact')}"
            placeholder="Enter contact"
          />
          <div v-if="errors.has('contact')" class="help is-danger">{{ errors.first('contact') }}</div>
          <primary-input
            type="text"
            name="rate email"
            v-model="vendor.rate_email"
            v-validate="'required|email'"
            :class="{'input': true, 'is-danger': errors.has('rate email')}"
            placeholder="Enter rate email"
          />
          <div
            v-if="errors.has('rate email')"
            class="help is-danger"
          >{{ errors.first('rate email') }}</div>
          <primary-input
            name="noc email"
            type="text"
            v-model="vendor.noc_email"
            v-validate="'required|email'"
            :class="{'input': true, 'is-danger': errors.has('noc email')}"
            placeholder="elyse_sauer@yahoo.com"
          />
          <div v-if="errors.has('noc email')" class="help is-danger">{{ errors.first('noc email') }}</div>
        </div>
        <div class="col">
          <p class="pimary-input-title">Change Photo</p>
          <edit-dropzone
            ref="userEditDropzone"
            @fileAdd="fileAdded($event)"
            @remove="fileRemoved($event)"
            class="upload-photo"
          ></edit-dropzone>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    PrimaryInput: () => import("@/components/Inputs/PrimaryInput.vue"),
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
    SecondaryButton: () => import("@/components/Buttons/SecondaryButton.vue"),
    PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
    EditDropzone: () => import("@/components/EditDropzone")
  },
  data: () => ({
    contactError: null,
    vendor: [],
    // {
    //   sales_email: null,
    //   noc_email: null,
    //   rate_email: null,
    //   vendor_name: null,
    //   vendor_type: 'MO',
    //   contact_person: null,
    //   logo_file_uuid: null,
    // },
    file: null,
    type: ["MO", "MT"],
    vendor_name: null
  }),
  created() {
    this.getVendor();
    console.log("this.vendor--->", this.vendor);
  },
  methods: {
    getVendor() {
      console.log("steeeeeee", this.$route.params.id);
      this.$store.dispatch("GetVendor", this.$route.params.id).then(res => {
        this.vendor = res; //.map();
        console.log(this.vendor);
        this.vendor_name = res.vendor_name;
        this.vendor = this.transformVendors(this.vendor, 0);
        this.GetFile();
      });
    },
    transformVendors(i, k) {
      console.log("iiiiiiiiiiiii", i);
      return {
        vendor_name: i.vendor_name,
        sales_email: i.sales_email,
        rate_email: i.rate_email,
        noc_email: i.noc_email,
        vendor_type: i.vendor_type,
        contact_person: i.contact_person,
        logo_file_uuid: i.logo_file_uuid
      };
    },
    GetFile() {
      if (this.vendor.logo_file_uuid) {
        console.log("this.contact.logo_file_uuid", this.vendor.logo_file_uuid);
        // this.file = `http://88.198.219.62/api_smsc/v1/file/${this.company.contact.logo_file_uuid}`;
        var mockFile = { size: 1024, name: "Userlogo", type: "image/png" };
        this.$refs.userEditDropzone.$el.dropzone.emit("addedfile", mockFile);
        this.$refs.userEditDropzone.$el.dropzone.emit(
          "thumbnail",
          mockFile,
          `http://88.198.219.62/api_smsc/v1/file/${this.vendor.logo_file_uuid}`
        );
        this.$refs.userEditDropzone.$el.dropzone.emit("complete", mockFile);
      }
    },
    fileAdded(file) {
      console.log(file);
      if (file.accepted) {
        this.file = file;
      }
    },
    fileRemoved() {
      this.file = null;
      this.vendor.logo_file_uuid = null
    },
    uploadPhoto: async function() {
      let data = new FormData();

      data.append("file", this.file);
      data.append("belongs_to", "vendor.logo");
      data.append("public", true);

      return await this.$store.dispatch("UploadFile", data);
    },
    addVendor: async function() {
      const valid = await this.$validator.validate();

      if (!valid) return;
      
      try {
        if (this.file) {
          let res = await this.uploadPhoto();
          this.vendor.logo_file_uuid = res.object_uuid;
        }
        // if(this.vendor_name = this.vendor.vendor_name) { delete this.vendor.vendor_name}

        await this.$store.dispatch("EditVendor", {
          vendor: this.vendor,
          id: this.$route.params.id
        });

        this.$snotify.success("Vendor has been edited.", {
          timeout: 6000
        });

        this.$router.push({ name: "reseller-vendors-list" });
      } catch (err) {
        if (err.errors) {
          this.contactError = err.errors[0].contact
            ? err.errors[0].contact
            : null;
          setTimeout(() => {
            this.contactError = null;
          }, 6000);
        } else {
          if (err.errors) {
            this.contactError = err.errors[0].invoice
              ? err.errors[0].invoice
              : null;
            setTimeout(() => {
              this.contactError = null;
            }, 6000);
          } else if(err.response) {
            this.$snotify.error(
              err.response.data.errors
                ? err.response.data.errors
                : err.response.data.error.message, { timeout: 6000 } );
          } else {
            this.$snotify.error(err, {  timeout: 6000 } );
          }
        }
      }
    }
  }
};
</script>

<style lang="scss">
.container {
  font-family: "Helvetica Neue";
  padding: 0 20px;
  .add-navigation {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    width: 100%;
    margin-top: 20px;
    margin-bottom: 20px;
    .back-link {
      cursor: pointer;
      display: flex;
      align-items: center;
      fill: #51a3f3;
      color: #51a3f3;
      font-family: "Helvetica Neue";
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;
      p {
        margin-bottom: 0;
      }
    }
    .buttons-wrapper {
      display: flex;
      align-items: center;
      width: fit-content;
      .primary-button {
        height: 40px;
        width: 130px;
      }
      .secondary-button {
        height: 40px;
        width: 90px;
        margin-right: 20px;
      }
    }
  }
  .add-container {
    flex-direction: column;
    align-items: center;
    height: 390px;
    background-color: #ffffff;
    padding-top: 15px;
    .container-title {
      height: 30px;
      width: 432px;
      color: #000000;
      font-size: 18px;
      font-weight: 500;
      line-height: 30px;
      padding: 15px 0 15px 15px;
    }
    .col-wrapper {
      width: 100%;
      display: flex;
      justify-content: space-between;
      margin-top: 20px;
      .col {
        width: 100%;
        padding-right: 15px;
        .input {
          margin-bottom: 20px;
        }
        .field {
          p.pimary-input-title {
            color: #000000;
            font-family: "Helvetica Neue";
            font-size: 12px;
            font-weight: 900;
          }
        }
        .upload-photo,
        #editdropzone {
          min-height: 285px;
          min-height: 285px;
          border-radius: 4px;
          width: 100%;
          .dz-preview {
            margin-left: -142px;
          }
          .dz-image {
            img {
              height: 255px;
              width: 285px;
              //border-radius: 50px;
            }
          }
        }
        .pimary-input-title {
          color: #000000;
          font-family: "Helvetica Neue";
          font-size: 12px;
          font-weight: 900;
          letter-spacing: 0.21px;
          line-height: 15px;
          margin-bottom: 5px;
          text-transform: uppercase;
        }
        .upload-contaioner {
          border: 1px solid #5171f3;
          border-radius: 4px;
          background-color: #ffffff;
          height: 265px;
          border-style: dashed;
          margin-right: 15px;
          position: relative;
          input[type="file"] {
            position: absolute;
            height: 36px;
            width: 136px;
            opacity: 0;
            cursor: pointer;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            -ms-transform: translate(-50%, -50%); /* IE 9 fix */
            z-index: 1;
          }
          .upload-button {
            height: 36px;
            width: 136px;
            border-radius: 4px;
            background-color: #51a3f3;
            margin: 0;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }
      }
    }
    .email-input {
      margin-bottom: 20px;
    }
    .password-input {
      margin-bottom: 30px;
    }
    .company {
      margin-bottom: 30px;
      .remember-me {
        display: flex;
        align-items: center;
        input {
          margin-right: 5px;
        }
      }
    }
  }
}
</style>

